module.exports = __webpack_public_path__ + "img/section10.007e88bc.png";